window.addEventListener("DOMContentLoaded", () => {
  let eventAdded = false;
  const cdpcpMenuNode = document.getElementById("cdproductcomparisonplus");
  const cdpcpMenuSlideOutNode = document.getElementById("cdpcp-menu-slideout");
  const cdpcpItems = document.getElementById("cdpcp-items");
  const config = { attributes: true, childList: true, subtree: true };
  const callback = (mutationList, observer) => {
    var _a;
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        const cdpcpMenuNumber = (_a = mutation.target) == null ? void 0 : _a.innerText;
        if (cdpcpMenuNumber <= 0) {
          cdpcpMenuNode.style.display = "none";
        } else {
          cdpcpMenuNode.style.display = "block";
        }
      }
    }
  };
  const anotherCallback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes") {
        const cdpcpSlideOutCompareBtn = document.querySelector(".cdpcp-btn-go-to-compare").children[0].children[0];
        const cdpcpMenuSlideOutNumber = cdpcpMenuSlideOutNode.children[0].children[0].children[0];
        if (!eventAdded) {
          const cdpcpRemoveBtn = document.querySelector(".cdpcp-remove-all");
          cdpcpRemoveBtn.addEventListener("click", () => {
            while (cdpcpItems.firstChild) {
              cdpcpItems.removeChild(cdpcpItems.firstChild);
            }
          });
          eventAdded = true;
        }
        if (cdpcpMenuNode.style.display === "block") {
          cdpcpMenuSlideOutNumber.innerText = Object.keys(cdpcpItems.children).length;
          cdpcpSlideOutCompareBtn.innerText = Object.keys(cdpcpItems.children).length;
          break;
        }
      }
    }
  };
  const cdpcpMenuObserver = new MutationObserver(callback);
  const cdpcpMenuSlideOutObserver = new MutationObserver(anotherCallback);
  cdpcpMenuObserver.observe(cdpcpMenuNode, config);
  cdpcpMenuSlideOutObserver.observe(cdpcpMenuSlideOutNode, config);
});
